import Axios from "./Axios";
import ENDPOINTS from "./endpoints";

export interface IRefund {
  refundId: number;
  orderId: number;
  orderNumber?: string;
  userId?: number;
  userName?: string;
  userEmail?: string;
  paymentTransactionId?: string | null;
  totalAmount?: number;
  orderDate?: number[] | string;
  requestedAt?: number[] | string;
  processedAt?: number[] | string | null;

  status?: string;

  items?: IRefundDetailItem[];
  refundDetails?: IRefundDetailItem[];
  [key: string]: any;
}

export interface IRefundDetailItem {
  refundDetailId: number;
  orderDetailId?: number;
  productId?: number;
  productName?: string;
  productImgUrl?: string;
  reason?: string;
  quantityOrdered?: number;
  quantityRefunded?: number;
  unitPrice?: number;
  refundStatus?: string;
  status?: string;

  processedMessage?: string;
  [key: string]: any;
}

type RefundFilterParams = {
  page?: number;
  size?: number;
  [key: string]: any;
};

const filterRefunds = (params: RefundFilterParams = {}) => {
  const { page = 0, size = 10, ...rest } = params;
  return Axios.get<any>(ENDPOINTS.refunds.filter, {
    params: { page, size, ...rest },
  });
};

const getAllRefunds = () => {
  return Axios.get<any>(ENDPOINTS.refunds.all);
};

const getRefundById = (refundId: number) => {
  return Axios.get<any>(ENDPOINTS.refunds.byId(refundId));
};

const updateRefundStatus = (refundId: number, status: string) => {
  return Axios.patch<any>(ENDPOINTS.refunds.updateStatus(refundId), { status });
};

export interface IRefundProcessItem {
  refundDetailId: number;
  quantityRefunded: number;
  refundStatus: "FULL_REFUNDED" | "PARTIALLY_REFUNDED" | "REJECTED";
  message?: string;
}

export interface IRefundProcessPayload {
  refundId: number;
  refundStatus: "FULL_REFUNDED" | "PARTIALLY_REFUNDED" | "REJECTED";
  items: IRefundProcessItem[];
}

const processRefund = (payload: IRefundProcessPayload) => {
  return Axios.post<any>(ENDPOINTS.refunds.process, payload);
};

const RefundService = {
  filterRefunds,
  getAllRefunds,
  getRefundById,
  updateRefundStatus,
  processRefund,
};

export default RefundService;
